import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import SOrderDetailmain from "../components/orders/OrderDetailmain";

const SOrderDetailScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <SOrderDetailmain />
      </main>
    </>
  );
};

export default SOrderDetailScreen;
